(() => {
  const fi = document.documentElement.lang.startsWith('fi');
  const t = (en, finnish) => fi ? finnish : en;
  let dialog, trigger, previousOverflow;
  const money = value => new Intl.NumberFormat(fi ? 'fi-FI' : 'en-IE', {style:'currency', currency:window.Shopify?.currency?.active || 'EUR'}).format(value / 100);
  window.gastroCartConfirmation = (result, source) => {
    const items = result.items || [result];
    if (!items.length) return;
    trigger = source || document.activeElement;
    if (!dialog) {
      dialog = document.createElement('dialog');
      dialog.className = 'gastro-added';
      dialog.setAttribute('aria-labelledby', 'gastro-added-title');
      dialog.innerHTML = '<button class="gastro-added-close" type="button" data-dismiss><svg viewBox="0 0 32 32" aria-hidden="true"><path d="m5 5 22 22M27 5 5 27"/></svg></button><div class="gastro-added-heading"><svg viewBox="0 0 32 32" aria-hidden="true"><circle cx="16" cy="16" r="13"/><path d="m10 16 4 4 8-9"/></svg><h2 id="gastro-added-title"></h2></div><div class="gastro-added-items"></div><div class="gastro-added-actions"><button type="button" data-dismiss></button><a></a></div>';
      dialog.querySelector('.gastro-added-close').setAttribute('aria-label', t('Close','Sulje'));
      dialog.querySelector('.gastro-added-actions button').textContent = t('Continue shopping','Jatka ostoksia');
      const cart = dialog.querySelector('.gastro-added-actions a');
      cart.textContent = t('Go to cart','Siirry ostoskoriin');
      cart.href = (window.Shopify?.routes?.root || '/') + 'cart';
      dialog.querySelectorAll('[data-dismiss]').forEach(button => button.addEventListener('click', () => dialog.close()));
      dialog.addEventListener('click', event => { if (event.target === dialog) { const r=dialog.getBoundingClientRect(); if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom) dialog.close(); } });
      dialog.addEventListener('close', () => {document.body.style.overflow=previousOverflow; if(trigger?.isConnected) trigger.focus();});
      document.body.append(dialog);
    }
    dialog.querySelector('h2').textContent = items.length > 1 ? t('Products added to cart','Tuotteet lisätty ostoskoriin') : t('Product added to cart','Tuote lisätty ostoskoriin');
    const list=dialog.querySelector('.gastro-added-items');
    list.replaceChildren();
    items.forEach(item => {
      const row=document.createElement('div'); row.className='gastro-added-product';
      row.innerHTML='<img alt=""><div><a></a><p class="gastro-added-code"></p><p class="gastro-added-price"><strong></strong> <s></s></p></div>';
      const image=row.querySelector('img'); const src=item.featured_image?.url || item.image;
      if(src) image.src=src; else image.hidden=true;
      const title=row.querySelector('a'); title.textContent=item.product_title || item.title; title.href=item.url || '#';
      row.querySelector('.gastro-added-code').textContent=item.sku ? t('Code: ','Tuotekoodi: ')+item.sku : '';
      const price=item.final_price ?? item.price;
      row.querySelector('strong').textContent=money(price);
      const original=item.original_price ?? item.price;
      row.querySelector('s').textContent=original>price ? money(original) : '';
      list.append(row);
    });
    if(!dialog.open){previousOverflow=document.body.style.overflow;document.body.style.overflow='hidden';dialog.showModal();}
  };
})();
